import React, { useContext } from "react";
import { Typography, Grid, Stack } from "@mui/joy";
import TableCustom from "../../components/TableCustome";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { green, grey, red } from "@mui/material/colors";
import { CardMedia } from "@mui/material";
import PageLooperContext from "../../providers/PageLooperContext";
import getProduitImageUrl from "../../utils/getProduitImageUrl";
import Colors from "../../constant/colors";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

interface PageContentCategorieProvinceProps {
    categorie: string;
    province: string;
    columns: string[]; // ["marche", "date", "produit1", "produit2", ...]
    data: { [key: string]: string | number }[]; // tableau des lignes
}

const PageContentCategorieProvince: React.FC<PageContentCategorieProvinceProps> = ({
    categorie,
    province,
    columns,
    data,
}) => {
    const { apiData } = useContext(PageLooperContext);

    // Construire une ligne spéciale pour les images
    const imageRow = Object.fromEntries(
        columns.map((col) => {
            if (col === "marche" || col === "date" ) {
                return [col, ""]; // pas d'image ici
            }
            const codeProduit = apiData.find((p) => p.produit.nomProduit === col)?.produit.codeProduit;
            return [
                col,
                codeProduit ? (
                    <CardMedia
                        key={col}
                        component="img"
                        src={getProduitImageUrl(codeProduit)}
                        sx={{ width: "4vw", height: "4vw", objectFit: "contain", margin: "auto" }}
                    />
                ) : "-",
            ];
        })
    );

    // Lignes du tableau 
    const tableRows = [
       
        ...data
        .filter (row => row.marche && row.marche !== "") 
        .map((row: any) =>
            Object.fromEntries(
                columns.map((col) => [
                    col,
                    col === "marche" ? (
                        row[col] || " -" // Affiche le nom du marché ou "-" si vide
                    ) : (
                        <b>
                            {col === "date"
                                ? row[col]
                                : row[col] == null || row[col] === "" // null, undefined, vide
                                    ? ""
                                    : row[col] < 0 // négatif → juste "-"
                                        ? "-"
                                        : row[col] > 0 // positif → valeur formatée
                                            ? `${row[col].toLocaleString()} FCFA`
                                            : "-"} {/* 0 → vide */}
                        </b>
                    ),
                ])
            )
        ),
         { ...imageRow, marche: " ", date: " " }, // ligne images
    ];


    return (
        <Stack sx={{ gap: 3, p: 4 }}>
            <Typography
                level="h4"
                fontSize={"2vw"}
                textColor={grey[700]}
                fontWeight={700}
            >
                Prix des produits de la catégorie{" "}
                <Typography fontWeight={700} textColor={green[900]}>
                    "{categorie}"
                </Typography>{" "}
                dans la Province de{" "}
                <Typography fontWeight={700} sx={{ color: Colors.secondary }}>
                    {province} {" "} 
                </Typography>
                
            </Typography>

            <Grid container flex={1} spacing={5} height={"100%"} direction={"column"}>
                <Grid xs={12}>
                    <TableCustom
                        columns={columns.map((col, index) => ({
                            label: col,
                            key: col,
                            center: !!index,
                        }))}
                        data={tableRows}
                    />
                </Grid>
            </Grid>
        </Stack>
    );
};

export default PageContentCategorieProvince;
